import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useSegment } from 'common/hooks/segment';
import * as React from 'react';

export enum EventFilter {
  AllEvents = 'All events',
  MilestonesOnly = 'Milestones only',
  InfoChangeOnly = 'Info change only',
}

const filters: EventFilter[] = [
  EventFilter.AllEvents,
  EventFilter.MilestonesOnly,
  EventFilter.InfoChangeOnly,
];

interface Props {
  filter: EventFilter;
  setFilter: (filter: EventFilter) => void;
}

export const Filter: React.FC<Props> = (props) => {
  const { filter, setFilter } = props;

  const { track } = useSegment();

  const onChange = React.useCallback(
    (e: SelectChangeEvent<EventFilter>) => {
      const newFilter = e.target.value as EventFilter;
      setFilter(newFilter);
      track(
        'Container side drawer history filter used',
        { filter: newFilter },
        { includeCompany: true, includeUser: true }
      );
    },
    [setFilter, track]
  );

  return (
    <Select
      variant="standard"
      value={filter}
      onChange={onChange}
      renderValue={(value) => value}
      MenuProps={{
        disablePortal: true,
      }}
      disableUnderline
    >
      {filters.map((value) => (
        <MenuItem key={value} value={value}>
          <h4 className="font-medium text-gray-700">{value}</h4>
        </MenuItem>
      ))}
    </Select>
  );
};
Filter.displayName = 'Shipments.DetailDrawer.Sections.History.Filter';
